import {
  tenantHasModule,
  type FeatureFlags,
  type FeatureKey,
  type TenantModule,
  type UserRole,
} from '@kennisbank/shared';

/**
 * Zichtbaarheidsregel voor sidebar-items (issue #38): rol én server-features
 * bepalen samen wat toont. Los van Layout.tsx zodat de regel puur en
 * unit-testbaar is; `features` afwezig (oudere backend) = alles tonen.
 *
 * `headOffice` op een item beperkt het tot kantoorpersoneel (isHeadOffice) en
 * suppohrt_admin — de kantoorvangnet-schermen (Beheer Declaraties) zijn voor
 * meer dan alleen admins, maar niet voor elke medewerker.
 *
 * `demoToegang` beperkt een item tot wie op de server-allowlist voor
 * demo-toegangscodes staat (/api/me `demoToegangBeheer`); de rol helpt dan niet.
 *
 * `module` verbergt een item als die module voor de tenant van de gebruiker uit
 * staat (TENANT_MODULES, ADR 0018). De backend weigert die routes ook (403).
 */
export function navItemVisible(
  item: {
    allowed?: UserRole[];
    feature?: FeatureKey;
    headOffice?: boolean;
    teamleider?: boolean;
    demoToegang?: boolean;
    verwijsbrief?: boolean;
    module?: TenantModule;
    nietBeschikbaar?: boolean;
  },
  role: UserRole,
  features: FeatureFlags | undefined,
  isHeadOffice = false,
  isTeamleider = false,
  demoToegangBeheer = false,
  verwijsbrief = false,
  tenantId?: string,
): boolean {
  // Staat de module uit voor de tenant, dan toont een `nietBeschikbaar`-item
  // toch, als ingang naar de "(nog) niet beschikbaar"-pagina (ADR 0018).
  if (item.module && !tenantHasModule(tenantId, item.module)) return item.nietBeschikbaar === true;
  return (
    (!item.verwijsbrief || verwijsbrief) &&
    (!item.allowed || item.allowed.includes(role)) &&
    (!item.feature || !features || features[item.feature]) &&
    (!item.headOffice ||
      isHeadOffice ||
      role === 'suppohrt_admin' ||
      (item.teamleider === true && isTeamleider)) &&
    (!item.demoToegang || demoToegangBeheer)
  );
}
